import React from "react";

/**
 * Renders a search icon as an SVG component.
 *
 * @param {string} cls - Additional class name for styling the SVG component
 * @return {JSX.Element} The search icon SVG component
 */
export const SearchIcon = ({ cls = "" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M22 22L17.514 17.506L22 22ZM20 11.5C20 13.7543 19.1045 15.9163 17.5104 17.5104C15.9163 19.1045 13.7543 20 11.5 20C9.24566 20 7.08365 19.1045 5.48959 17.5104C3.89553 15.9163 3 13.7543 3 11.5C3 9.24566 3.89553 7.08365 5.48959 5.48959C7.08365 3.89553 9.24566 3 11.5 3C13.7543 3 15.9163 3.89553 17.5104 5.48959C19.1045 7.08365 20 9.24566 20 11.5V11.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
